import { IMDSSwitchFloatyProps } from "./switch-floaty.types";
import { RightContainer, LeftContainer, StyledSwitchFloaty } from "./switch-floaty.style";
import { IMDSSwitchVariant, MDSSwitch } from "@/mds/components/forms";
import { MdsIcon } from "@/design-system/components/icon";
import { useState } from "react";
import { MDSText, MDSTextColor, MDSTextVariant, MDSTextWeight } from "@/mds/components/text";

export const MDSSwitchFloaty = (props: IMDSSwitchFloatyProps) => {
  const { iconKind, label, style, defaultSelected, onChange, switchProps, ...buttonProps } = props;
  const [selected, setSelected] = useState(defaultSelected);

  const handleClick = () => {
    if (buttonProps.isDisabled) return;
    const value = !selected;
    handleChange(value);
  };

  const handleChange = (value: boolean) => {
    setSelected(value);
    onChange?.(value);
  };

  return (
    <StyledSwitchFloaty
      onPress={handleClick}
      {...buttonProps}
      style={style}
      data-selected={selected}
    >
      <LeftContainer>
        {iconKind && <MdsIcon kind={iconKind} />}
        {label && (
          <MDSText
            variant={MDSTextVariant.TextS}
            weight={MDSTextWeight.Smedium}
            color={selected ? MDSTextColor.Emphasis : MDSTextColor.Primary}
          >
            {label}
          </MDSText>
        )}
      </LeftContainer>

      <RightContainer>
        <MDSSwitch
          {...switchProps}
          variant={IMDSSwitchVariant.TOGGLE}
          isSelected={selected}
          onChange={handleChange}
          style={{ cursor: "pointer" }}
        />
      </RightContainer>
    </StyledSwitchFloaty>
  );
};
